// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
import Store from '../vuex/store';
// 登录
import login from '@/views/login';

import testPage from '../views/testPage';

// 注册
import register from '@/views/register';
// 找回密码
import retrievePassword from '@/views/retrievePassword';

import initialPasswordSet from "@/views/initialPasswordSet";

// 用户协议
import userAgreement from '@/views/userAgreement';


// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 限时折扣
import limitDiscounts from '@/views/limitDiscounts/index'
// 秒杀
import spike from '@/views/spike/index'

// 红包页面
import redenvelopes from '@/views/redenvelopes/index'
// 品牌
import brand from '@/views/brand/index'
// 商品列表
import goodsList from '@/views/goodsList/index'
//专题页面
import topicIndex from '@/views/topicPages/topicIndex'

// 商品详情
import goodsDetail from '@/views/goodsList/goodsDetail'
// 商家入驻 系列
import settleInLayout from '@/views/merchantSettled/settleInLayout'
import welcomesystem from '@/views/merchantSettled/welcomesystem'
import merchantTypeSelect from '@/views/merchantSettled/merchantTypeSelect'
import merchantApply from '@/views/merchantSettled/merchantApply'
import merchantForm from '@/views/merchantSettled/merchantForm'
import merchantStatus from '@/views/merchantSettled/merchantStatus'
import merchantpayFor from '@/views/merchantSettled/menchantpayFor'
import storeOpen from '@/views/merchantSettled/storeOpen'

// 购物车
import shoppingcart from '@/views/shoppingcart/shoppingcart'
import orderDetail from '@/views/shoppingcart/orderDetail'
import orderNow from '@/views/shoppingcart/orderNow'
import wxERweima from '@/views/shoppingcart/wxERweima'

// 头部客户服务的 相关文章分类
import serviceArticle from '@/views/serviceArticle/index'
import articleDetail from '@/views/serviceArticle/articleDetail'

// 我的订单
import myOrder from '@/views/myOrder/index'
import myOrderRight from '@/views/myOrder/myOrder'
import goodsAppraisal from '@/views/myOrder/evaluationePage/goodsAppraisal'
import orderAppraisal from '@/views/myOrder/evaluationePage/orderAppraisal'
import gotoEvaluation from '@/views/myOrder/evaluationePage/gotoEvaluation'
import evaluationDetail from '@/views/myOrder/evaluationePage/evaluationDetail'
import pointsOrder from '@/views/myOrder/pointsOrder'
import myOrderDetail from '@/views/myOrder/myOrderDetail'
import myRefund from '@/views/myOrder/customerService/myRefund'

// 关注中心
import goodsCollection from '@/views/myOrder/attentionCenter/goodsCollection' // 商品收藏
import myFooter from '@/views/myOrder/attentionCenter/goodsHistory' // 我的足迹
import shopCollection from '@/views/myOrder/attentionCenter/shopCollection' // 店铺收藏
// 支付成功
import paySuccess from '@/views/paySuccess'

// 个人中心
import myInfomation from '@/views/myOrder/myCenter/myInfo' // 个人信息
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 账号安全
// import myInfo from '@/views/myOrder/myCenter/myInfo' // 绑定授权
import address from '@/views/myOrder/myCenter/address'  // 收货地址

// 客户服务
import refund from '@/views/myOrder/customerService/refund' // 退款退货
import refundDetail from '@/views/myOrder/refundDetail' // 退款退货
import consultation from '@/views/myOrder/customerService/consultation' // 商品咨询

// 财产中心
import myRedPack from '@/views/myOrder/propertyCenter/myRedPack'  // 我的红包
import myScores from '@/views/myOrder/propertyCenter/myScores' // 我的积分
import myCashCoupons from '@/views/myOrder/propertyCenter/myCashCoupons' // 我的积分

// 首页main
import main from '@/views/dashboard/main';
// 首页-店铺街
import store from '@/views/store/store';
import storeHome from '@/views/store/storeHome';
import shopCert from '@/views/store/storeCert';
import storeClose from '@/views/merchantSettled/storeClose';


/** 供应商 **/
// 首页
import supplier from '@/views_supplier/index';
// 首页main
import main_supplier from '@/views_supplier/dashboard/main';
// 首页-店铺街
import store_supplier from '@/views_supplier/store/store';
// 商品列表
import goodsList_supplie from '@/views_supplier/goodsList/index'
// 联系我们
import contactUs from '@/views_supplier/contactUs/contactUs';
// 商品详情
import goodsDetail_supplie from '@/views_supplier/goodsList/goodsDetail'
// 购物车
import shoppingcart_supplie from '@/views_supplier/shoppingcart/shoppingcart'
// 下单
import orderDetail_supplie from '@/views_supplier/shoppingcart/orderDetail'

/** 供应商 **/
// 我的订单
import myOrder_supplier from '@/views_supplier/myOrder/index'
import myOrderRight_supplier from '@/views_supplier/myOrder/myOrder'
// import goodsAppraisal_supplier from '@/views_supplier/myOrder/goodsAppraisal'
import myOrderDetail_supplier from '@/views_supplier/myOrder/myOrderDetail'
import myRefund_supplier from '@/views_supplier/myOrder/myRefund'
// 个人中心
// import address_supplier from '@/views_supplier/myOrder/myCenter/address'  // 收货地址
// 财产中心
// import myRedPack_supplier from '@/views_supplier/myOrder/propertyCenter/myRedPack'  // 我的红包


/** 积分商城 **/
import pointMall from '@/views/pointMall/pointMall'
// 积分商城 积分商品详情
import pointsProDetails from '@/views/pointMall/pointsProDetails'

/** 站点导航 **/
import siteNavigation from '@/views/siteNavigation/siteNavigation'
import userCenter from '@/views/siteNavigation/userCenter'
import paymentCenter from '@/views/siteNavigation/paymentCenter'

/** 直播 **/
import liveList from '@/views/live/liveList';

/** 我的邀请 **/
import myInvite from "../views/myOrder/myInvite/myInvite";
import myInviteData from "../views/myOrder/myInvite/myInviteData";
import noticeList from "../views/noticeList/noticeList";

// 启用路由
Vue.use(Router);
import TopicRoutes from './topicRoutes';
import storeCert from "@/views/store/storeCert";

// 导出路由
const router = new Router({
  mode: 'history',  //去掉url中的#
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return {x: 0, y:0};
  },
  routes: [
    {
      path: '/',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      redirect: '/',
      hidden: true,
      meta: {
        requireAuth: false
      },
      children: [
        ...TopicRoutes,
        {
          path: '/',
          name: '嵌套在首页',
          component: main,
          meta: {
            requireAuth: false
          }
        },{
          path: '/live',
          name: '直播',
          component: liveList,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/store',
          name: '店铺街',
          component: store,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/noticeList',
          name: '公告消息',
          component: noticeList,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shopStore',
          name: '店铺详情',
          component: storeHome,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/storeCert',
          name: '店铺证照',
          component: storeCert,
          meta: {
            requireAuth: false
          }
        },
        // {
        //     path: '/storeHome',
        //     name: '店铺详情',
        //     component: storeHome,
        //     meta: {
        //         requireAuth: false
        //     }
        // },
        {
          path: '/shoppingcart',
          name: '购物车',
          component: shoppingcart,
          hidden: true,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/orderDetail',
          name: '购物车订单',
          component: orderDetail,
          hidden: true,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/orderNow',
          name: '购物车付款',
          component: orderNow,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/paySuccess',
          name: '支付成功',
          component: paySuccess,
          hidden: true,
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/redenvelope',
          name: '红包',
          component: redenvelopes,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/brand',
          name: '品牌',
          component: brand,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/goodsList',
          name: '商品列表',
          component: goodsList,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/topicIndex',
          name: '专题页',
          component: topicIndex,
          hidden: true,
          meta: {
            requireAuth: false
          }
        }, {
          path: '/goodsDetail',
          name: '商品详情',
          component: goodsDetail,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/pointMall',
          name: '积分商城',
          component: pointMall,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        // pointsProDetails
        {
          path: '/pointsProDetails',
          name: '积分商城',
          component: pointsProDetails,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/limitDiscounts',
          name: '限时折扣',
          component: limitDiscounts,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/spike',
          name: '秒杀',
          component: spike,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: '/gotoEvaluation',
          name: '去评价',
          component: gotoEvaluation
        },
        {
          path: '/orderAppraisal',
          name: '订单评价',
          component: orderAppraisal
        },
        {
          path: '/evaluationDetail',
          name: '商品评价详情',
          component: evaluationDetail
        },
        {
          path: '/articleList',
          name: '文章列表',
          component: serviceArticle,
        },
        {
          path: '/articleDetail',
          name: '文章详情',
          component: articleDetail,
        },
        {
          path: '/myOrder',
          name: '我的订单',
          redirect: '/myOrderRight',
          component: myOrder,
          hidden: true,
          meta: {
            requireAuth: true
          },
          children: [
            {
              path: '/myOrderRight',
              name: '我的订单',
              component: myOrderRight,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/myOrderDetail',
              name: '订单详情',
              component: myOrderDetail
            },
            {
              path: '/myRefund',
              name: '退款编写',
              component: myRefund
            },
            {
              path: '/refundDetail',
              name: '退款详情',
              component: refundDetail
            },
            {
              path: '/goodsAppraisal',
              name: '商品评价',
              component: goodsAppraisal
            },
            {
              path: '/pointsOrder',
              name: '积分订单',
              component: pointsOrder
            },
            {
              path: '/goodsCollection',
              name: '商品收藏',
              component: goodsCollection,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/shopCollection',
              name: '店铺收藏',
              component: shopCollection
            },
            {
              path: '/myFooter',
              name: '我的足迹',
              component: myFooter,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myInfomation',
              name: '个人信息',
              component: myInfomation,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myInvite',
              name: '我的邀请',
              component: myInvite,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/myInviteData',
              name: '交易数据',
              component: myInviteData,
              meta: {
                requireAuth: true
              },
            },
            {
              path: '/address',
              name: '收获地址',
              component: address
            },
            {
              path: '/refund',
              name: '退款退货',
              component: refund
            },
            {
              path: '/consultation',
              name: '商品咨询',
              component: consultation
            },
            {
              path: '/myScores',
              name: '我的积分',
              component: myScores
            },
            {
              path: '/myRedPack',
              name: '我的红包',
              component: myRedPack
            },
            {
              path: '/myCashCoupons',
              name: '我的代金券',
              component: myCashCoupons
            }
          ]
        },
      ]
    },
    {
      path: '/settleIn',
      name: '商家入驻',
      component: settleInLayout,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: 'welcomesystem',
          name: '商家入驻欢迎',
          component: welcomesystem,
          meta: {
            requireAuth: true
          }
        }, {
          path: 'merchantTypeSelect',
          name: '商家入驻选择',
          component: merchantTypeSelect,
          meta: {
            requireAuth: true
          }
        },
        {
          path: 'merchantApply',
          name: '商家入驻协议',
          component: merchantApply,
          meta: {
            requireAuth: false
          }
        }, {
          path: 'merchantForm',
          name: '商家入驻表单',
          component: merchantForm,
          meta: {
            requireAuth: true
          }
        }, {
          path: 'merchantStatus',
          name: '商家入驻平台审核',
          component: merchantStatus,
          meta: {
            requireAuth: true
          }
        }, {
          path: 'merchantpayFor',
          name: '商家入驻平台交费',
          component: merchantpayFor,
          meta: {
            requireAuth: true
          }
        }, {
          path: 'storeOpen',
          name: '商家入驻店铺开通',
          component: storeOpen,
          meta: {
            requireAuth: true
          }
        }, {
          path: 'storeClose',
          name: '店铺关店',
          component: storeClose,
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/testPage',
      name: '测试页面',
      component: testPage,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: '登录',
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
        path: '/register',
        name: '注册',
        component: register,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
      path: '/retrievePassword',
      name: '找回密码',
      component: retrievePassword,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/initialPasswordSet',
      name: '修改登录初始密码',
      component: initialPasswordSet,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/userAgreement',
      name: '用户协议',
      component: userAgreement,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wxERweima',
      name: '微信支付二维码',
      component: wxERweima,
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/siteNavigation',
      name: '站点导航首页',
      component: siteNavigation,
      iconCls: 'el-icon-tickets',
      redirect: '/userCenter',
      hidden: true,
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: '/userCenter',
          name: '用户中心',
          component: userCenter,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/paymentCenter',
          name: '支付中心',
          component: paymentCenter,
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
})
// 路由拦截器
router.beforeEach((to, from, next) => {
  if (to.matched.length !== 0) {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
      if (Store.getters.isLogin) { // 通过vuex state获取当前的user是否存在
        next();
      } else {
        next({
          path: '/login',
          query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      next();
    }
  } else {
    next({
      path: '/login',
      query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js